import AltLayout from 'Nori/Layout/AltLayout';
import Hero from 'Custom/Hero';
import RichText from 'Custom/RichText';
import QUESTIONS_IMAGE from 'Images/misc/question-yellow.webp';
import FAQWrapper from 'Custom/FAQ/FAQWrapper';
import FinderSimple from 'Custom/Finder/FinderSimple';
import ActionStrip from 'Custom/ActionStrip';
import styles from 'styles/pages/questions.module.scss';
import { SPANISH_JOB_CODE } from 'Custom/Footer/es/Footer.utils';

import {
  FAQ_EXPLORING_QUESTIONS,
  FAQ_NEXPLANON_USERS,
} from 'Utils/es/questions';

const HERO_IMAGE = {
  src: QUESTIONS_IMAGE,
  width: 400,
};

const HERO_IMAGE_MOBILE = {
  src: QUESTIONS_IMAGE,
};

const HEAD = {
  title:
    'Preguntas frecuentes sobre NEXPLANON® (etonogestrel implant) 68 mg Radiopaque',
  keywords: 'preguntas sobre nexplanon',
  description:
    'Revise las preguntas y respuestas frecuentes sobre NEXPLANON® (etonogestrel implant) 68 mg Radiopaque, incluidas las preguntas sobre la inserción de NEXPLANON y cómo funciona.',
  hreflang: 'es-us',
};

export default function QuestionsSpanish() {
  return (
    <AltLayout head={HEAD} jobCode={SPANISH_JOB_CODE}>
      <Hero
        title="PREGUNTAS FRECUENTES"
        background="secondary4Light"
        variant="overlap"
        image={HERO_IMAGE}
        mobileImage={HERO_IMAGE_MOBILE}
        imageBreakpoint="xl"
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Hero"
        data-design-module_name="PREGUNTAS FRECUENTES"
        data-design-module_no="01"
      >
        <RichText>
          <h2>
            a continuación están las preguntas más frecuentes sobre NEXPLANON
          </h2>
          <p>Y, por supuesto, respuestas a esas preguntas.</p>
        </RichText>
      </Hero>

      <FAQWrapper
        className={styles.firstAccordion}
        title={'acerca de NEXPLANON'}
        questions={FAQ_EXPLORING_QUESTIONS}
        moduleNumber="02"
      />

      <FAQWrapper
        title={'usuarias de NEXPLANON'}
        questions={FAQ_NEXPLANON_USERS}
        moduleNumber="03"
      />

      <FinderSimple
        designModuleNo="04"
        title="¿lista para NEXPLANON?"
        buttonLabel="Encuentra un médico"
        buttonHref="/what-is-nexplanon/#find-a-doctor"
      >
        Encuentra un profesional de la salud capacitado e inicia la
        conversación.
      </FinderSimple>
    </AltLayout>
  );
}
